import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface CaseListItemDTO {
  id: string;
  caseNumber: string;
  caseType: string;
  contactName: string;
  subject: string;
  opened: moment.Moment | null;
  status: string;
  owner: string;
}
const CaseListItemDTO = {
  create: (initValues?: Partial<CaseListItemDTO>): CaseListItemDTO => {
    const defaults: CaseListItemDTO = {
      id: '',
      caseNumber: '',
      caseType: '',
      contactName: '',
      subject: '',
      opened: null,
      status: '',
      owner: '',
    };
    const fixedInitValues: Partial<CaseListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
        opened: ObjectUtil.ToMoment(initValues.opened),
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default CaseListItemDTO;
